import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/computer-with-clock.svg'


const _hoisted_1 = {
  id: "modal-request-in-progress",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "contact-wrapper" }
const _hoisted_6 = { class: "contact py-3" }
const _hoisted_7 = { class: "contact-item" }
const _hoisted_8 = { class: "modal-footer py-3" }

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalRequestInProgress',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const arStore = useAR()

  onMounted(() => {
    modal.value = new Modal('#modal-request-in-progress', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-header pb-3" }, [
          _createElementVNode("h5", { class: "modal-title" }, "Solicitação em andamento")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
            _createTextVNode(" Sua solicitação está em "),
            _createElementVNode("strong", null, "andamento.")
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
            _createTextVNode(" Fique tranquilo! "),
            _createElementVNode("strong", null, "Você será notificado por e-mail"),
            _createTextVNode(" quando sua solicitação for concluída e poderá prosseguir com a instalação. ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contact-item" }, [
                _createElementVNode("span", { class: "color--primary fw-600" }, " Ficou alguma dúvida? ")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(IconComponent, {
                  class: "icon mx-1",
                  name: "phone"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(arStore).$state.arData.foneAR), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "btn btn-primary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createVNode(IconComponent, {
                name: "house",
                class: "me-2"
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" Página inicial "))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})